export enum StepsId {
  Main = 'Main',
  MemberOnlyAccess = 'MemberOnlyAccess'
}

export type GoToStepFn = (stepId: StepsId) => void;
